var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fg-input',{attrs:{"label":_vm.label}},[_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","format":"dd.MM.yyyy","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }